import CustomerAPI from 'api/customers'

export const socialLoginAPI = (params, callback) => async (dispatch) => {
  const response = await CustomerAPI.socialLogin(params)
  callback(response.data)
}

export default socialLoginAPI
